import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { StaticHeaderComponent } from './_widgets/static-header/static-header.component';
import { LoaderComponent } from './loader/loader.component';
import { AmlService } from './_services/aml.service';
import { LoaderService } from './_services/loader.service';
import { combineLatest, forkJoin, map } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, StaticHeaderComponent, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'sign-ng';
  private amlService = inject(AmlService);
  private loaderService = inject(LoaderService);

  get isLoading$() {
    return this.loaderService.isLoading;
  }

  get sseLoading$() {
    return this.amlService.isLoading;
  }
}
